<script>
	export let row = {};
	export let key = "";
	export let event = () => {};
	export let options = [];
	export let selectableKey = "";
	export let selectableValue = undefined;

	$: checked = options.includes(row[key]);
	$: selectable = !selectableKey || row[selectableKey] === selectableValue;
</script>

<input
	type="checkbox"
	aria-label="Select {row[key]}"
	{checked}
	disabled={!selectable}
	on:click={(e) => e.stopPropagation()}
	on:change={() => selectable && event(row)}
/>
